export default __webpack_public_path__ + "7ea5aab46e8ea54892661ad07b7ee58f.png";